"use client";

// Top-level state machine for the magic terminal. The whole subtree is
// forced to dir="ltr" so the IDE-style overlays (with traffic lights on
// the right, code typing left-to-right, etc.) stay consistent on the
// Hebrew locale where the document direction is RTL.

import { AnimatePresence } from "motion/react";
import { BuildPipeline } from "./build-pipeline";
import { DeployStream } from "./deploy-stream";
import { TerminalHero } from "./terminal-hero";
import { useSceneState } from "./use-scene-state";

export function TerminalScene() {
  const state = useSceneState();

  return (
    <div dir="ltr" className="contents">
      <AnimatePresence mode="sync" initial={false}>
        {state === "hero" && <TerminalHero key="hero" />}
        {state === "fragmented" && <BuildPipeline key="pipeline" />}
        {state === "crystals" && <DeployStream key="deploy" />}
        {/* "final" → laissé vide pour ne pas chevaucher le formulaire de contact */}
      </AnimatePresence>
    </div>
  );
}
